import axios from 'axios';
import { getBaseUrl } from "../../service/apiUrl";
const { createSlice, createAsyncThunk } = require('@reduxjs/toolkit');

export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getLeaderBoardoffollowingcompetition = createSlice({
    name: 'LeaderBoardoffollowingcompetition',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },
 
    extraReducers: (builder) => {
        builder
            .addCase(fetchLeaderBoardoffollowingcompetition.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchLeaderBoardoffollowingcompetition.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE;
            })
            .addCase(fetchLeaderBoardoffollowingcompetition.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    },
});

export const { setLeaderBoardoffollowingcompetition, setStatus } = getLeaderBoardoffollowingcompetition.actions;
export default getLeaderBoardoffollowingcompetition.reducer;

export const fetchLeaderBoardoffollowingcompetition = createAsyncThunk('competition-v2/leaderboard/races/fetch', async () => {
    const res = await axios.get(`${getBaseUrl()}/competition-v2/leaderboard/races`)
    const data =  res.data;
    return data.data;
});